const _ = require('./_');
const setUtil = require('./array-util');
const { moment } = require('./date-util');

// replaces _.isEqual and allows field order to change
function isEqual(a, b, falsyEqualsFalsy = false) {
  if ((a && !b) || (b && !a)) {
    return false;
  }

  if (_.isObject(a)) {
    if (!_.isObject(b)) {
      return false;
    }
    const allKeys = _.union(Object.keys(a), Object.keys(b));
    return allKeys.every(k => isEqual(a[k], b[k]));
  }

  if (Array.isArray(a)) {
    if (!Array.isArray(b)) {
      return false;
    }
    return a.every((o, i) => isEqual(a[i], b[i]));
  }

  // 0 is a case of falsy where we consider it different to '', but we allow '', null, undefined to be the same
  return _.isEqual(a, b) || (falsyEqualsFalsy && !a && !b && (a !== 0) && (b !== 0));
}

function getObjectChanges(oldObject, newObject) {
  const oldFieldValues = Object.keys(oldObject).map(k => ({ key: k, value: oldObject[k] }));
  const newFieldValues = Object.keys(newObject).map(k => ({ key: k, value: newObject[k] }));

  return setUtil.getChanges(oldFieldValues, newFieldValues, i => i.key);
}

function compareField(a, b, fieldName) {
  if (_.has(a, fieldName) && _.has(b, fieldName)) {
    if (_.isNumber(a[fieldName]) && _.isNumber(b[fieldName])) {
      return a[fieldName] - b[fieldName];
    }

    if (_.isString(a[fieldName]) && _.isString(b[fieldName])) {
      if (a[fieldName] < b[fieldName]) {
        return -1;
      }
      if (b[fieldName] < a[fieldName]) {
        return 1;
      }
      return 0;
    }

    if (_.isDate(a[fieldName]) && _.isDate(b[fieldName])) {
      return moment(a[fieldName]).diff(b[fieldName], 'seconds');
    }

    if (a[fieldName] === b[fieldName]) {
      return 0;
    }

    return a[fieldName] - b[fieldName];
  }

  if (_.has(a, fieldName)) {
    return -1;
  }
  if (_.has(b, fieldName)) {
    return 1;
  }

  return 0;
}

function compareFieldsInOrder(a, b, fieldNames) {
  for (let i = 0; i < fieldNames.length; i++) {
    const compareResult = compareField(a, b, fieldNames[i]);
    if (compareResult !== 0) {
      return compareResult;
    }
  }
  return 0;
}

module.exports = {
  isEqual,
  getObjectChanges,
  compareField,
  compareFieldsInOrder,
};
